import { QuestionCircleOutlined } from '@ant-design/icons'
import { Form, Modal, Select } from 'antd'
import { string } from 'prop-types'
import { useCallback, useMemo, useRef, useState } from 'react'
import { PageHeader } from '~/components/PageHeader'
import { useTableDataSourceKey } from '~/hooks/useTableDataSourceKey'
import CourseTable from '../CourseTable'
import {
  useAssignCourseUser,
  useDeleteCourseMutation,
  useDuplicateCourseMutation
} from '../mutation'
import { useGetDoctors, usePastCoursesQuery } from '../query'

const { confirm } = Modal

const PastCourses = ({ filterInput }) => {
  const { data: pastCourses, isLoading: pastCoursesLoading } = usePastCoursesQuery()
  const pastCoursesSource = useTableDataSourceKey(pastCourses)
  const { mutate: deleteCourse } = useDeleteCourseMutation()
  const { mutate: duplicateCourse } = useDuplicateCourseMutation()

  const [openAssignUserModel, setOpenAssignUserModel] = useState(false)
  const [selectedCourse, setSelectedCourse] = useState()
  const { mutate: AssignCourseUserMutate } = useAssignCourseUser()
  const assignUserForm = useRef()
  const handleAssignServer = useCallback((values) => {
    AssignCourseUserMutate(
      {
        course_id: selectedCourse?.id,
        ...values
      },
      {
        onSuccess: () => {
          setOpenAssignUserModel(false)
        }
      }
    )
  }, [selectedCourse?.id, AssignCourseUserMutate])

  const confirmDelete = (courseId, courseName) => {
    confirm({
      title: 'Confirm',
      icon: <QuestionCircleOutlined />,
      content: `Do you want to delete course ${courseName}?`,
      okText: 'YES',
      okType: 'danger',
      cancelText: 'NO',
      onOk: () => {
        deleteCourse(courseId)
      }
    })
  }

  const filterPastCourses = useMemo(() => {
    const filter = filterInput.toLowerCase()
    if (!pastCoursesSource) {
      return 0
    }

    return pastCoursesSource.filter((course) => course.name.toLowerCase().includes(filter))
  }, [pastCoursesSource, filterInput])

  const { data } = useGetDoctors()

  return (
    <>
      <PageHeader className="radup-page-header" />

      <CourseTable
        data={filterPastCourses}
        loading={pastCoursesLoading}
        duplicateCourse={duplicateCourse}
        confirmDelete={confirmDelete}
        setOpenAssignUserModel={setOpenAssignUserModel}
        setSelectedCourse={setSelectedCourse}
      />

      <Modal
        title={'Assign a user'}
        open={openAssignUserModel}
        destroyOnHidden
        onOk={() => {
          assignUserForm.current.submit()
        }}
        onCancel={() => setOpenAssignUserModel(false)}
      >
        <Form ref={assignUserForm} preserve={false} onFinish={handleAssignServer}>
          <Form.Item label="User" name="user_id">
            <Select
              showSearch
              optionFilterProp='label'
              options={data?.map(item => ({
                value: item.id,
                label: item.name
              }))}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}

PastCourses.propTypes = {
  filterInput: string.isRequired
}

export default PastCourses
